<template>
    <div class="intelligence-chart">
        <h3 class="intelligence-chart__title">{{ $t('pages.intelligence.supply_demand.charts.by_specialty') }}</h3>
        <div v-if="hasData" class="intelligence-chart__body">
            <apexchart type="bar" height="320" :options="chartOptions" :series="series"></apexchart>
        </div>
        <p v-else class="intelligence-chart__empty">{{ $t('pages.intelligence.supply_demand.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            rows: {
                type: Array,
                default: () => [],
            },
        },

        computed: {
            topRows() {
                return this.rows.slice(0, 10)
            },

            hasData() {
                return this.topRows.some((row) => row.demandCount > 0 || row.supplyProviderCount > 0)
            },

            series() {
                return [
                    {
                        name: this.$t('pages.intelligence.supply_demand.table.demand'),
                        data: this.topRows.map((row) => row.demandCount),
                    },
                    {
                        name: this.$t('pages.intelligence.supply_demand.table.supply'),
                        data: this.topRows.map((row) => row.supplyProviderCount),
                    },
                ]
            },

            chartOptions() {
                return {
                    chart: {
                        type: 'bar',
                        toolbar: { show: false },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            borderRadius: 4,
                            barHeight: '60%',
                        },
                    },
                    colors: ['#1e3a8a', '#059669'],
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        categories: this.topRows.map((row) => row.specialityName),
                    },
                    legend: {
                        position: 'top',
                    },
                    grid: {
                        borderColor: '#e5e7eb',
                    },
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-chart {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-chart__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-chart__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
